<template>
  <v-card>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <img src="https://randomuser.me/api/portraits/men/88.jpg">
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Immanuel Kant</v-list-item-title>
          <v-list-item-subtitle>What is Enlightment</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            :class="fav ? 'red--text' : ''"
            icon
            @click="fav = !fav"
          >
            <v-icon>mdi-heart</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

<!--         <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch v-model="message" color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch v-model="hints" color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item>
        </v-list>
 -->

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn text @click="logoutRequest">Settings</v-btn>
      <v-btn color="primary" text @click="logoutRequest()">Sign Out</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
// import { mapGetters } from 'vuex'
import { bus } from '../main'

export default {
  name: 'ProfilePopUp',
  data: () => ({
    fav: true,
  }),
  methods: {
    logoutRequest () {
      bus.$emit('ProfilePopUpVisible', false);

      this.$store.dispatch("logout");
      this.$router.replace('/signin');
    }
  },
}


</script>


<style scoped>

</style>
